/* eslint-disable no-unused-vars */
import React from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { togglePopup } from '../../../../../Redux/popups/popupSlice'
import { ReactComponent as PulmonologyIcon } from '../../../../../assets/icons/pulmonology.svg'
import { ReactComponent as StomatologyIcon } from '../../../../../assets/icons/stomatology.svg'
import { useTranslation } from 'react-i18next'

const Index = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { operations, loading } = useSelector((state) => state.operations)
  const auth = useSelector((state) => state.auth)
  const { profile } = auth?.user || {}
  const isAdmin = profile?.role === 'admin'

  const toggleUserAddingPopup = () => {
    if (!isAdmin) return
    dispatch(
      togglePopup({
        pointer: 2,
        data: null
      })
    )
  }

  const toggleEditUser = (op) => {
    if (!isAdmin) return
    dispatch(
      togglePopup({
        pointer: 2,
        data: op
      })
    )
  }

  const deleteOp = (op) => {
    if (!isAdmin) return
    dispatch(
      togglePopup({
        pointer: 2,
        data: { ...op, deleteData: true }
      })
    )
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.user_list_caption}>{t('operations_list')}</h2>
        {isAdmin && (
          <button className={`${styles.add_user}`} onClick={toggleUserAddingPopup}>
            {t('add_new_operation')}
          </button>
        )}
      </div>
      <div className={styles.op_list}>
        {operations?.map((operation) => {
          return (
            <div key={operation.id} className={styles.op_card}>
              <div className={styles.op_info}>
                <p
                  style={{
                    backgroundColor: operation.color,
                    color: operation.color === '#ffffff' ? 'black' : 'white'
                  }}
                  className={styles.user_name}
                >
                  {operation.op_name}
                </p>
              </div>
              <div className={styles.op_info}>
                <p className={styles.operation_category}>
                  {operation.category === 'pulmonology' ? (
                    <PulmonologyIcon className={styles.icon} />
                  ) : (
                    <StomatologyIcon className={styles.icon} />
                  )}
                  {' ' + operation.category}
                </p>
              </div>
              <div className={styles.op_info}>
                <p className={styles.user_name}>{`${operation.unitary ? t('unit') : t('full')} : ${operation.price}€`}</p>
              </div>
              {isAdmin && (
                <div className={styles.user_control}>
                  <button className={`${styles.manage_button}`} onClick={() => toggleEditUser(operation)}>
                    {t('edit')}
                  </button>
                  <pre className={styles.seperator} />
                  <button className={`${styles.manage_button} ${styles.delete_btn}`} onClick={() => deleteOp(operation)}>
                    {t('delete')}
                  </button>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Index
